if (!customElements.get("contact-form-section")) {
  customElements.define(
    "contact-form-section",
    class ContactFormSection extends HTMLElement {
      connectedCallback() {
        this.form = this.querySelector("form.contact-form__form");
        if (!this.form) return;

        this.fields = this.form.querySelectorAll(
          "input:not([type='hidden']), textarea, select"
        );

        this.form.addEventListener("submit", this.onSubmit.bind(this));

        this.fields.forEach((field) => {
          field.addEventListener("invalid", this.onInvalid.bind(this));
          field.addEventListener("input", this.onInput.bind(this));
          field.addEventListener("change", this.onInput.bind(this));
        });
      }

      onSubmit(event) {
        if (!this.form.checkValidity()) {
          event.preventDefault();
          this.fields.forEach((field) => {
            if (!field.validity.valid) this.markInvalid(field);
          });
          this.form.querySelector(":invalid")?.focus();
        }
      }

      onInvalid(event) {
        event.preventDefault();
        this.markInvalid(event.target);
      }

      onInput(event) {
        const field = event.target;
        if (field.validity.valid) {
          field.classList.remove("is-invalid");
          field.removeAttribute("aria-invalid");
        }
      }

      markInvalid(field) {
        field.classList.add("is-invalid");
        field.setAttribute("aria-invalid", "true");
      }
    }
  );
}
